
























































































































import { Component, Vue, Watch } from 'nuxt-property-decorator';
import { mapState } from 'vuex';

import SignUpSocialButtons from './SignUpSocialButtons/SignUpSocialButtons.vue';
import SignUpForm from './SignUpForm/SignUpForm.vue';
import { NUMBER_OF_USERS } from './constants';
import ModalBlack from './ModalBlack/ModalBlack.vue';
import CurrentTitleAutocomplete from '@/components/common/CurrentTitleAutocomplete/CurrentTitleAutocomplete.vue';
import { isUserInsideExternalApp, isSalesGptReferrer } from '~/utils/externalRedirections';
import Modal from '@/components/common/Modal/Modal.vue';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import { COOKIE_NAME_SAVED_JOB_TITLE } from '@/components/common/constants';
import FadeTransition from '@/components/common/Transitions/FadeTransition.vue';

@Component<SignUpModal>({
  name: 'SignUpModal',
  components: {
    Modal,
    ModalBlack,
    SignUpSocialButtons,
    SignUpForm,
    CurrentTitleAutocomplete,
    BravadoButtonV3,
    FadeTransition,
  },
  computed: {
    ...mapState(['promo']),
  },
})
export default class SignUpModal extends Vue {
  isUserInsideExternalApp: boolean = false;
  isLoading: boolean = false;
  NUMBER_OF_USERS: string = NUMBER_OF_USERS;
  promo!: string;
  jobTitle: string = '';
  isAdditionalQuestionOpened: boolean = false;
  linkToOAuthPage!: string;

  /**
   * We show additional question about job title only on /login-external before sign up
   */
  get withAdditionalQuestion(): boolean {
    return (
      this.$route.name === this.$pages.LOGIN_EXTERNAL_PAGE.name &&
      !this.isUserInsideExternalApp &&
      this.isSalesGptReferer
    );
  }

  get referer(): string {
    const { query } = this.$route;
    return (query?.refferer || query?.referer) as string;
  }

  get loginParams() {
    return {
      ...(this.promo && { promo: this.promo }),
      auth_source: 'sign-up-modal',
    };
  }

  get isSalesGptReferer() {
    return isSalesGptReferrer(document.referrer) || this.referer?.includes('search');
  }

  mounted() {
    this.isUserInsideExternalApp = isUserInsideExternalApp(
      document.referrer,
      navigator.userAgent,
      this.$device.isWebView,
    );
  }

  onSocialLogin(provider: 'google' | 'linkedin', linkToOAuthPage?: string) {
    if (this.withAdditionalQuestion) {
      this.linkToOAuthPage = linkToOAuthPage!;
      this.isAdditionalQuestionOpened = true;
    }

    this.$analytics.logEvent(`global__war-room-sign-up-modal__${provider}-button__click`);
  }

  navigateToSignIn() {
    this.$analytics.logEvent('global__war-room-sign-up-modal__login-link__click');
    this.$modal.showWithRoute('SIGN_IN_MODAL');
  }

  handleJobTitleChanged(jobTitle: string) {
    this.jobTitle = jobTitle;
  }

  handleAdditionalAnswerReplied() {
    this.$analytics.logEvent('global__war-room-sign-up-modal__additional-answer__submit');
    this.$cookies.set(COOKIE_NAME_SAVED_JOB_TITLE, this.jobTitle, { maxAge: 60 * 60 * 24, path: '/' }); // 1 day
    this.$nextTick(() => {
      window.location.assign(this.linkToOAuthPage);
    });
  }

  @Watch('isAdditionalQuestionOpened')
  handleScreenChanged() {
    if (this.isAdditionalQuestionOpened) {
      // Set focus after the animation to prevent the keyboard from popping up
      setTimeout(() => {
        (this.$refs.additionalQuestion as HTMLInputElement).querySelector('input')?.focus();
      }, 500);
    }
  }
}
